export const APP_NAME = 'Gopher for Chrome Premium';
